import { HashViews } from './hash-views';
import { FieldConfig, FieldDataTypes, ModelInterface, Uuid } from '@hidat/huijs-common';
import { HasTenantResource, NestUpdateTrackingResource, ResourceConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';
import { SplixerResourceType, SplixerResourceTypes } from './splixer-resource-types';

// Item to replace tags ??????

/**
 * Listener Items
 * These are all the things that a listener has taken note of.  These can be tags, likes, 'list items', etc.
 * Items can be attached to a resource (host, program, track), or attached to an external URL
 * (think BandCamp or YouTube links that come from a comment).
 * This then gives the user a chance to come back and use these items for some useful purposes later.
 */

export const ListenerItemConfig: ResourceConfig = new ResourceConfig(
  'ListenerItem',
  'listener_items',
  true,
  true,
)
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.status,
      new FieldConfig('resourceType'),
      new FieldConfig('externalContentUrl'),
      new FieldConfig('itemKlass'),
      new FieldConfig('tags'),
      new FieldConfig('itemAttributes', FieldDataTypes.HASH),
      new FieldConfig('subscriptionStatus', FieldDataTypes.INTEGER),
      new FieldConfig('reviewStatus', FieldDataTypes.INTEGER),
      new FieldConfig('reviewedOn', FieldDataTypes.DATETIME),
      new FieldConfig('count', FieldDataTypes.INTEGER),
    ],
    true,
    HashViews.player,
  )
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.instanceId,
    splixerFieldConfigs.listenerId,
    splixerFieldConfigs.guidId,
    new FieldConfig('resourceId', FieldDataTypes.INTEGER),
  ]);

export const ListenerItemKlasses = {
  Tag: 'Tag',
  Like: 'Like',
  List: 'List',
};

export type ListenerItemKlass = (typeof ListenerItemKlasses)[keyof typeof ListenerItemKlasses];

export const ListenerItemListTags = {
  ListenList: 'ListenList',
  WatchList: 'WatchList',
  ReadList: 'ReadList',
};

export interface ListenerItemAttributes {
  note?: string;
  artist?: string;
  album?: string;
  track?: string;
}

//export type ListenerItemResourcesTypes = Pick<typeof SplixerResourceTypes, 'Mix' | 'Program' | 'Show' | 'Host' | 'MediaTitle'>;
export type ListenerItemResourcesType = Extract<
  SplixerResourceType,
  'Mix' | 'Program' | 'Show' | 'Host' | 'MediaTitle' | 'PlaybackLog'
>;


/**
 * Listener Items.  This includes list items, tags, likes, etc...
 * Can be associated with a listener or just an instance if the listener hasn't given us their email address already.
 */
export interface PlayerListenerItemInterface extends ModelInterface {
  itemKlass: ListenerItemKlass | undefined;
  tags: string | undefined; // should this be an array?
  resourceType: ListenerItemResourcesType | undefined;
  resourceUid?: Uuid;
  externalContentUrl: string | undefined;
  itemAttributes: ListenerItemAttributes | undefined;
  count: number | undefined;
  subscriptionStatus: number | undefined;
  reviewStatus: number | undefined;
  reviewedOn: unknown; //datetime
}
export interface ListenerItemInterface
  extends
    PlayerListenerItemInterface,
    NestUpdateTrackingResource,
    HasTenantResource {
  resourceId: number | undefined;
  listenerId: Uuid | undefined;
  instanceId: number | undefined;
}
